export default "__VITE_ASSET__te7FnHYK__"